export default "__VITE_ASSET__ZyffBsTl__"